import shipmentFrag from "./Shipment";
import WarehouseLocation from "./WarehouseLocation";
import WarehouseSite from "./WarehouseSite";
import warehouseItemFrag from "./WarehouseItem";

const WarehouseMove = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    item = false,
    location = false,
    shipment = false,
    site = false,
    bondref = includeDefaults,
    date = includeDefaults,
    goodsCode = includeDefaults,
    confirmed = includeDefaults,
    itemId = includeDefaults,
    locationId = includeDefaults,
    locref = includeDefaults,
    shipmentId = includeDefaults,
    siteId = includeDefaults,
    ti = includeDefaults,
    taDays = includeDefaults,
    user = includeDefaults,
    value = includeDefaults,
  } = propsObj;

  return `
  id
  ${bondref ? `bondref` : ""}
  ${date ? `date` : ""}
  ${goodsCode ? `goodsCode` : ""}
  ${confirmed ? `confirmed` : ""}
  ${
    item
      ? `item {
      ${warehouseItemFrag(item)}
    }`
      : ""
  }
  ${itemId ? `itemId` : ""}
  ${
    location
      ? `location {
      ${WarehouseLocation(
        typeof location === "object" && location !== null ? location : {},
      )}
    }`
      : ""
  }
  ${locationId ? `locationId` : ""}
  ${locref ? `locref` : ""}
  ${
    shipment
      ? `shipment {
      ${shipmentFrag(shipment)}
    }`
      : ""
  }
  ${shipmentId ? `shipmentId` : ""}
  ${siteId ? `siteId` : ""}
  ${
    site
      ? `site {
      ${WarehouseSite}
    }`
      : ""
  }
  ${ti ? `ti` : ""}
  ${taDays ? `taDays` : ""}
  ${user ? `user` : ""}
  ${value ? `value` : ""}
`;
};

export default WarehouseMove;
